import { Typography } from "components/parts/Typography/Typography";
import { colors } from "constants/colors";
import styled from "styled-components";

export const StyledReportContainer = styled.div`
  height: calc(100% - 60px);
`;

// TODO:改ページと余白
export const ReportBaseMain = styled.main`
  @page {
    size: A4 portrait;
    margin: 20mm;
  }
  height: 100%;

  .page-break-after {
    page-break-after: always;
  }
  padding: 1rem;
`;

export const ReportLayoutDiv = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
`;

export const ReportBaseDiv = styled.div`
  background-color: ${colors.white};
  height: 100%;
  width: 80%;
  padding: 20px 5%;
  overflow-y: scroll;
  box-sizing: border-box;
  @media print {
    width: 210mm;
    height: 297mm;
  }
`;

export const StyledTextHeader = styled.h1`
  font-size: 26px;
  text-align: center;
`;

export const StyledCellContainer = styled.div`
  margin-top: 50px;
  padding: 10px;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;

  page-break-after: always;
  > * {
    margin-bottom: 1rem;
  }
`;

export const StyledCellHeader = styled.h2`
  font-size: 18px;
  text-align: left;
  text-decoration: underline;
  margin-bottom: 10px;
`;

export const StyledCellSecondHeader = styled(Typography)`
  display: inline-block;
  margin-bottom: 10px;
`;

export const StyledMarginDiv = styled.div`
  width: 100%;
  margin-bottom: 30px;

  @media print {
    break-inside: avoid;
  }
`;
